// frontend/src/app/store.js
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

// Core API Slice (मौजूदा)
import { apiSlice } from './api/apiSlice';

// Standard Redux Slices (मौजूदा वाले और category, content)
import authReducer from '../features/auth/authSlice';
import eventReducer from '../features/events/eventSlice';
import bhajanReducer from '../features/bhajans/bhajanSlice';
import categoryReducer from '../features/categories/categorySlice'; // ✅ Category UI state slice
import contentReducer from '../features/contents/contentSlice';   // ✅ NEW: Content UI state slice

// RTK Query API Slices (मौजूदा वाले और categoriesApiSlice, contentApiSlice)
import { eventsApiSlice } from '../features/events/eventsApiSlice';      // ✅ Events API slice (मौजूदा कोड से)
import { categoriesApiSlice } from '../features/categories/categoriesApiSlice'; // ✅ Categories API slice
import { contentApiSlice } from '../features/contents/contentApiSlice'; // ✅ NEW: Content API slice
// import { carouselApiSlice } from '../features/carousel/carouselApiSlice'; // ❌ NOT ADDED YET (as per instruction)
// import { usersApiSlice } from '../features/users/usersApiSlice';          // ❌ NOT ADDED YET (as per instruction)
import galleryImagesReducer from "../features/galleryImages/galleryImagesSlice";

export const store = configureStore({
    reducer: {
        // Core API Slice Reducer (मौजूदा)
        [apiSlice.reducerPath]: apiSlice.reducer,

        // Standard Redux Slices Reducers (मौजूदा वाले और category, content)
        auth: authReducer,
        event: eventReducer,
        bhajan: bhajanReducer,
        category: categoryReducer,    // ✅ Category UI state reducer
        content: contentReducer,      // ✅ NEW: Content UI state reducer
        // carousel: carouselReducer, // ❌ NOT ADDED YET
        galleryImages: galleryImagesReducer,
        // RTK Query API Slices Reducers (मौजूदा वाले और categoriesApiSlice, contentApiSlice)
        [eventsApiSlice.reducerPath]: eventsApiSlice.reducer,      // ✅ Events API slice reducer
        [categoriesApiSlice.reducerPath]: categoriesApiSlice.reducer, // ✅ Categories API slice reducer
        [contentApiSlice.reducerPath]: contentApiSlice.reducer,    // ✅ NEW: Content API slice reducer
        // [carouselApiSlice.reducerPath]: carouselApiSlice.reducer, // ❌ NOT ADDED YET
        // [usersApiSlice.reducerPath]: usersApiSlice.reducer,        // ❌ NOT ADDED YET
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(
            apiSlice.middleware,
            eventsApiSlice.middleware,     // ✅ Events API slice middleware
            categoriesApiSlice.middleware, // ✅ Categories API slice middleware
            contentApiSlice.middleware,    // ✅ NEW: Content API slice middleware
            // carouselApiSlice.middleware, // ❌ NOT ADDED YET
            // usersApiSlice.middleware,    // ❌ NOT ADDED YET
        ),
    devTools: true // Redux DevTools Extension को सक्षम करें
});

setupListeners(store.dispatch);